import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { UserState } from "./model";

let state: UserState = {
  users: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<UserState, RootStateType>;
